var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 8,
  width: 40,
  height: 8.5,
  fill: "#dfe6ec"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 15.2,
  width: 40,
  height: 1.3,
  fill: "#b4bfc6"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 16.5,
  width: 40,
  height: 21,
  fill: "#c8d6e0"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 16.5,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 12.5,
  y: 16.5,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 22.5,
  y: 16.5,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 32.5,
  y: 16.5,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 7.5,
  y: 21.75,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 21.75,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 27.5,
  y: 21.75,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 37.5,
  y: 21.75,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 27,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 12.5,
  y: 27,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 22.5,
  y: 27,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 32.5,
  y: 27,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 7.5,
  y: 32.25,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 32.25,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 27.5,
  y: 32.25,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 37.5,
  y: 32.25,
  width: 5,
  height: 5.25,
  fill: "#aec1cf"
});

function SvgFlooring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlooring);
export default __webpack_public_path__ + "static/media/flooring.1b024614d5ae96cf1610cb3d942ec4a5.svg";
export { ForwardRef as ReactComponent };